module.exports = __webpack_public_path__ + "img/icon-arrow arrow-up.33ac6606.svg";